import { Box, styled } from "@mui/material";

export const MediaBox = styled(Box)`
  display: flex;
  width: 90px;
  height: 90px;
  margin: 2px;
  border-radius: 5px;
  border: 1px solid #f1f5f8;
  position: relative;
  background-color: #f1f5f8;
`;

export const DocBox = styled(Box)`
  display: flex;
  align-self: center;
  width: inherit;
  padding: 15px;
`;
